import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Params, Router } from '@angular/router'
import { Location } from '@angular/common'

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {
  status
  statusText
  message

  constructor(private route: ActivatedRoute, private router: Router, private location: Location) {}

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.status = params.status
      this.statusText = params.statusText
      this.message = params.message
    })
  }

  back(): void {
    this.location.back()
  }
}
